import { Rule } from 'antd/es/form'
import { generalStrings } from 'src/common/generalStrings'
import { yupSyncGenerator } from 'src/common/helpers'
import * as yup from 'yup'

const schema = yup.object({
  clinical_name: yup.string().nullable().notRequired(),
  name: yup.string().required(generalStrings.requiredFieldValidation),
})

export const yupSync: Rule = yupSyncGenerator(schema)
